export const ROLE = {
  SUPER: 0,
  AGENT_ADMIN: 1,
  AGENT_SUB: 2,
  AGENT_AUDIT: 3,
  AGENT_ANNOUNCE: 4,
}

Object.freeze(ROLE)

export const BASE_PATH = {
  0: 'agentList',
  1: 'dashboard',
  2: 'dashboard',
  3: 'dashboard',
  4: 'notificationAgentAdmin',
}

Object.freeze(BASE_PATH)

export const STATUS_REQUEST = {
  SUCCESS: 'success',
  FAILED: 'failed',
}

export const LEVEL_ADMIN = {
  0: 'システム管理者',
  1: '管理者',
  2: 'サブ管理者',
  3: '閲覧者',
  4: '広告配信者',
  5: '許可なし',
}

Object.freeze(LEVEL_ADMIN)

export const COMMENT_LEVEL = {
  0: '-',
  1: '不足',
  2: '低い',
  3: '標準',
  4: '高い',
  5: '超過',
  6: '十分',
}

Object.freeze(COMMENT_LEVEL)

export const COMMENT_LEVEL_FAT = {
  0: '-',
  1: '不足',
  2: '標準',
  3: '高い',
  4: '超過',
}

Object.freeze(COMMENT_LEVEL_FAT)

export const COMMENT_LEVEL_MUS = {
  0: '-',
  1: '不足',
  2: '低い',
  3: '標準',
  4: '十分',
}

Object.freeze(COMMENT_LEVEL_FAT)

export const GENDER = {
  0: '女性',
  1: '男性',
}

Object.freeze(GENDER)

export const KEYCODE = {
  BACKSPACE: 8,
  ESC: 27,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  DELETE: 46,
  NUMBER_ZERO: 48,
  NUMBER_NINE: 57,
  NUM_LOCK_ZERO: 96,
  NUM_LOCK_NINE: 105,

  CHAR_E: 69,
  CHAR_E_SPECIAL: 231,
}

Object.freeze(KEYCODE)

export const DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm'
export const DATE_FORMAT = 'yyyy-MM-dd'
export const DATE_TIME_FORMAT_SPACING = 'yyyy-MM-dd   HH:mm'
export const MONTH_TIME_FORMAT = 'yyyy/MM'

export const TIME_SELECT = {
  day: '1',
  week: '2',
  month: '3',
}

export const NOTIFICATION_STATUS = {
  0: '配信待ち',
  1: '配信中',
  2: '配信終了',
  3: '無効化',
  4: '無効化申請中',
}

Object.freeze(NOTIFICATION_STATUS)

export const PLACE = {
  APP: 1,
  CMS: 0,
}

Object.freeze(PLACE)

export const PLACE_DETAIL = {
  1: 'アプリ',
  0: 'cms',
}

Object.freeze(PLACE_DETAIL)

export const NOTIFICATION_STATUS_NAME = {
  WAITING_FOR_DELIVERY: 0,
  DELIVERY: 1,
  END_OF_DELIVERY: 2,
  DISABLED: 3,
  APPLICATION_FOR_INVALIDATION: 4,
}

Object.freeze(NOTIFICATION_STATUS_NAME)

export const GENDER_OPTIONS = [
  {
    label: '男性',
    value: '1',
  },
  {
    label: '女性',
    value: '0',
  },
  {
    label: '指定なし',
    value: '2',
  },
]

Object.freeze(GENDER_OPTIONS)

export const WEIGHT_RANGE = [
  {
    label: '不足',
    value: '1',
  },
  {
    label: '低い',
    value: '2',
  },
  {
    label: '標準',
    value: '3',
  },
  {
    label: '高い',
    value: '4',
  },
  {
    label: '超過',
    value: '5',
  },
]

Object.freeze(WEIGHT_RANGE)

export const BODY_FAT_RATE_RANGE = [
  {
    value: '2',
    label: '低い',
  },
  {
    value: '3',
    label: '標準',
  },
  {
    value: '4',
    label: '高い',
  },
  {
    value: '5',
    label: '超過',
  },
]

Object.freeze(BODY_FAT_RATE_RANGE)

export const LOW_STANDARD_SUFFICIENT = [
  {
    value: '2',
    label: '低い',
  },
  {
    value: '3',
    label: '標準',
  },
  {
    value: '4',
    label: '十分',
  },
]

Object.freeze(LOW_STANDARD_SUFFICIENT)

export const LOW_STANDARD_HIGH = [
  {
    label: '低い',
    value: '2',
  },
  {
    label: '標準',
    value: '3',
  },
  {
    label: '高い',
    value: '4',
  },
]

Object.freeze(LOW_STANDARD_HIGH)

export const LOW_HIGH = [
  {
    value: '2',
    label: '低い',
  },
  {
    value: '4',
    label: '高い',
  },
]

Object.freeze(LOW_HIGH)

export const STANDARD_HIGH_EXCESS = [
  {
    label: '標準',
    value: '2',
  },
  {
    label: '高い',
    value: '3',
  },
  {
    label: '超過',
    value: '4',
  },
]

Object.freeze(STANDARD_HIGH_EXCESS)

export const TAG = [
  '',
  'お知らせ',
  'トレーニング',
  'アドバイス',
  'スケジュール',
  'キャンペーン',
  'クーポン',
]

Object.freeze(TAG)

export const DELIVERED = {
  ON: '0',
  OFF: '1',
}

Object.freeze(DELIVERED)

export const DELIVERED_OPTIONS = [
  {
    label: 'ON',
    value: '0',
  },
  {
    label: 'OFF',
    value: '1',
  },
]

Object.freeze(DELIVERED_OPTIONS)

export const UNIT = [
  {
    name: '体重',
    unit: 'kg',
  },
  {
    name: '除脂肪体重',
    unit: 'kg',
  },
  {
    name: '総筋肉量',
    unit: 'kg',
  },
  {
    name: '骨量',
    unit: 'kg',
  },
  {
    name: '体脂肪率',
    unit: '%',
  },
  {
    name: '皮下脂肪',
    unit: '%',
  },
  {
    name: '体水分率',
    unit: '%',
  },
  {
    name: '骨格筋',
    unit: '%',
  },
  {
    name: 'タンパク質',
    unit: '%',
  },
  {
    name: '内臓脂肪',
    unit: '',
  },
  {
    name: '基礎代謝',
    unit: 'kcal',
  },
  {
    name: 'BMI',
    unit: '',
  },
  {
    name: '体内年齢',
    unit: '',
  },
]

Object.freeze(UNIT)

export const NOTIFICATION_FILTER_DIFFER_NULL = -9999
